import React from "react";
import {ValidatedValue} from "../../../helpers/validatedValue";
import i18n from "../../../i18n/i18n";
import {Popup} from "../../../common/components/shared/popup/popup";
import "./downloadReportPopup.scss";
import {Api} from "../../../helpers/api";
import FileSaver from "file-saver";
import RadioGroup from "../../../common/components/shared/radioGroup/radioGroup";
import {RadioModel} from "../../../common/models/radio";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import Row from "../../../common/components/shared/row/row";
import {Utils} from "../../../helpers/utils";
import {ReportFileFormat} from "../../models/reportFileFormatEnum";

interface DownloadReportPopupProps {
    reportService: any | undefined;
    onCancel: () => void;
    isSummaryReport: boolean;
    selectedFilters: any;
}

interface DownloadReportPopupState {
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    submitButtonBlocked: boolean;
    formatValue: ValidatedValue<ReportFileFormat>;
}

class DownloadReportPopup extends React.Component<DownloadReportPopupProps, DownloadReportPopupState> {
    constructor(props: any) {
        super(props);

        this.state = {
            response: undefined,
            submitButtonBlocked: false,
            formatValue: new ValidatedValue(ReportFileFormat.xls)
        };
    }

    render() {
        return <Popup
            open={true}
            className="download-report-popup"
            header={i18n.t("reports.actions.download.header")}
            content={this.renderContent()}
            actionText={i18n.t("reports.actions.download.actionText")}
            action={this.submit.bind(this)}
            cancel={this.props.onCancel}
            testId="download-report-popup"
            isWaiting={this.state.submitButtonBlocked}
            httpError={
                <>
                    {!Api.isSuccess(this.state.response) && (
                        <HttpError
                            response={this.state.response}
                            cause={this.props.isSummaryReport ? i18n.t("reports.errors.downloadSummaryReportErrorSuffix") : i18n.t("reports.errors.downloadErrorSuffix")}
                        />
                    )}
                </>
            }
        />;
    }

    private renderContent(): JSX.Element {
        return <div className="container">
            <Row class="flex-type gap-30">
                <RadioGroup
                    testId="format"
                    items={this.formats}
                    validatedValue={this.state.formatValue}
                    radioGroupClassName={"formats-radio-group"}
                />
            </Row>
        </div>;
    }

    private get formats(): RadioModel[] {
        return [
            {value: ReportFileFormat.xls, label: ReportFileFormat.xls.toUpperCase()},
            {value: ReportFileFormat.csv, label: ReportFileFormat.csv.toUpperCase()},
        ];
    }

    private mediaType(format: ReportFileFormat) {
        switch (format) {
            case ReportFileFormat.xls:
                return "application/xls";
            case ReportFileFormat.csv:
                return "application/csv";
        }
    }

    private async executeDownload(filters: any, format: ReportFileFormat) {
        this.setState({response: undefined});

        let response = undefined;
        if (this.props.isSummaryReport) {
            response = await this.props.reportService.downloadSummaryReport(filters, format);
        } else {
            response = await this.props.reportService.download(filters, format);
        }

        this.setState({response});

        if (response && Api.isSuccess(response) && response.headers) {
            const fileName = response.headers["content-disposition"].split("filename=")[1];
            const blob = new Blob([response.data], {type: this.mediaType(this.state.formatValue.value)});
            FileSaver.saveAs(blob, fileName);
            this.props.onCancel();
        }
    }

    private async submit() {
        this.state.formatValue.validate();

        const valid = this.state.formatValue.isValid;
        if (valid) {
            this.setState({submitButtonBlocked: true});
            await this.executeDownload(this.props.selectedFilters, this.state.formatValue.value);
            this.setState({submitButtonBlocked: false});
        }
        Utils.scrollToFirstErrorMessage();
    }
}

export default DownloadReportPopup;
